module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isAuthorized) ? _c('button', {
    staticClass: "part-catalog-card-defer",
    class: _vm.classes,
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b420f6a2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/defer/component.vue
// module id = 08fd8143bb74e50d76c4
// module chunks = 0